import _ from 'underscore';
import { DataSourceState } from '@bingads-webui-react/image-picker'; // eslint-disable-line
import { getVideoObjectForImagePickerFromMTObject } from '../../util/video-converter';

class UserVideoDataSource {
  constructor(options) {
    this.currentData = [];

    this.sortById = options.sortById;
    this.videoRepository = options.videoRepository;
    this.currentSearchTerm = '';

    this.pageSize = 20;
  }

  subscribe(callback) {
    this.callback = callback;
  }

  unsubscribe() {
    this.callback = null;
  }

  excuteCallBackIfExsit(status) {
    if (this.callback) {
      this.callback(status);
    }
  }

  loadMore() {
    this.currentPage += 1;

    return this.fetchVideoAsync();
  }

  reload() {
    this.currentData = [];
    this.currentPage = 0;

    this.excuteCallBackIfExsit(DataSourceState.Done);

    return this.fetchVideoAsync();
  }

  searchAsync(searchTerm, sortById) {
    this.currentData = [];

    this.excuteCallBackIfExsit(DataSourceState.Done);

    if (searchTerm === null) {
      this.currentSearchTerm = '';
    } else {
      this.currentSearchTerm = searchTerm;
    }
    this.sortById = sortById || this.sortById;
    this.currentPage = 0;

    return this.fetchVideoAsync();
  }

  /* istanbul ignore next */
  replace(videoFromMT) {
    const index = this.currentData.findIndex(item => videoFromMT.Id === item.idString);
    if (index < 0) {
      console.warn(`unable to find video id: ${videoFromMT.id} in currentData`);
      return;
    }
    this.currentData[index] = getVideoObjectForImagePickerFromMTObject(videoFromMT);

    this.currentData = [...this.currentData];

    this.excuteCallBackIfExsit(DataSourceState.Done);
  }

  fetchVideoAsync() {
    this.excuteCallBackIfExsit(DataSourceState.Loading);

    return this.videoRepository.getVideos({
      sortById: this.sortById,
      searchTerm: this.currentSearchTerm,
      pageNumber: this.currentPage,
      pageSize: this.pageSize,
    }).then((response) => {
      this.hasMore = response['@odata.count'] > _.get(response, ['value', 'length'], 0) + this.currentData.length;
      const moreData = _.map(response.value, getVideoObjectForImagePickerFromMTObject);

      this.currentData = this.currentData.concat(moreData);
    }).finally(() => {
      this.excuteCallBackIfExsit(DataSourceState.Done);
    });
  }

  getData() {
    return { hasMore: this.hasMore, data: this.currentData };
  }
}

const initializeUserVideoDataSource = ({
  videoRepository,
}) => {
  const userVideoDataSource = new UserVideoDataSource({
    videoRepository,
    sortById: 1,
    filter: (() => true),
  });

  return userVideoDataSource;
};

export { UserVideoDataSource, initializeUserVideoDataSource };
